module.exports = __webpack_public_path__ + "img/logoarica-blanco.bbad2cbb.webp";